<script lang="ts" setup>
const props = defineProps({
  alignment: {
    default: 'left',
    type: String as PropType<CompanyAppsAlignment>,
  },
  apps: {
    default: () => ({}),
    type: Object as PropType<CompanyV2Apps>,
  },
  hasTooltip: {
    default: false,
    type: Boolean,
  },
  max: {
    default: Number.POSITIVE_INFINITY,
    type: Number,
  },
  reorder: {
    default: true,
    type: Boolean,
  },
  size: {
    default: 'sm',
    type: String as PropType<CompanyAppsSize>,
  },
})

const { t } = useI18n()

const order: CompanyAppsKeys[] = [
  'amazon',
  'chrome',
  'android',
  'ios',
  'mac',
  'meta',
  'microsoft',
  'playstation',
  'xbox',
]

const formattedApps = computed(() => {
  return Object.entries(props.apps)
    .filter(([appName]) => order.includes(appName as CompanyAppsKeys))
    .flatMap(([appName, appList]) =>
      (appList || []).map(
        app => ({
          name: app?.id || appName,
          type: appName as CompanyAppsKeys,
          url: app.url || '',
        }),
      ),
    )
    .sort((current, next) => {
      if (!props.reorder) {
        return 0
      }

      return order.indexOf(current.type as CompanyAppsKeys) - order.indexOf(next.type as CompanyAppsKeys)
    })
    .slice(0, props.max)
})
</script>

<template>
  <div
    class="flex flex-wrap items-center"
    :class="{
      'justify-start': alignment === 'left',
      'justify-center': alignment === 'center',
      'justify-end': alignment === 'right',
      'gap-1.5': size === 'xs',
      'gap-2': size === 'sm',
      'gap-3': size === 'lg',
      'gap-4': size === 'xl',
    }"
  >
    <template
      v-for="app in formattedApps"
      :key="app.name"
    >
      <UTooltip :text="hasTooltip ? `${t(`apps.${app.type}`)} (${app.name})` : ''">
        <ULink
          :class="{
            'size-4': size === 'xs',
            'size-5': size === 'sm',
            'size-6': size === 'lg',
            'size-7': size === 'xl',
          }"
          target="_blank"
          :to="app?.url"
        >
          <UIcon
            :class="{
              'size-4': size === 'xs',
              'size-5': size === 'sm',
              'size-6': size === 'lg',
              'size-7': size === 'xl',
            }"
            :name="getIcon(app.type as UIcon)"
          />
        </ULink>
      </UTooltip>
    </template>
  </div>
</template>
